"use strict"

import React, { useState } from "react"
import { Button, OverlayTrigger, Popover } from "react-bootstrap"

import { showModal, hideModal } from "../../../../utils"
import { isLTPM, id_accessor } from "../../../../../components/shared_components_registration"
import { toggle_annotations_button } from "../../../../../components/shared_components_registration_overflow"
import { withAnnotationsConfig } from "../../../../config/AnnotationConfigProvider"

const { EditAnnotationsModal, CreateAnnotationModal } = toggle_annotations_button

// Where we set distinctions for LTPM/LL versions of the component
// TODO - Need Translations (if we ever turn this feature on for LTPM)
const registration = {
  annotations_allowed: !isLTPM,
  manage_annotations_title: (intl) => (isLTPM ? "" : "Manage Annotations"),
  delete_annotations_title: (intl) => (isLTPM ? "" : "Delete Annotations"),
  show_annotations_title: (intl) => (isLTPM ? "" : "Show Annotations"),
}

function ToggleAnnotationsButton({
  // AnnotationConfigProvider
  show_annotation_lines,
  x_axis_value,
  showCreateModal,
  activeRun,
  activeGraph,
  hideCreateAnnotationsModal,
  toggleAnnotationsView,
  // --- AnnotationConfigProvider

  // Passed Props
  annotations = [],
  placement = "bottom",
  plotList,
  exportBaseName,
  run,
  intl,
  // --- Passed Props
}) {
  const [showEditModal, setShowEditModal] = useState(false)

  const overlay = (
    <Popover id="manage_annotations" title={registration.manage_annotations_title(intl)}>
      <Popover.Header as={"h3"}>{registration.manage_annotations_title(intl)}</Popover.Header>
      <Popover.Body>
        <div style={{ textAlign: "center" }}>
          <Button
            className={show_annotation_lines ? "btn-selected" : ""}
            variant={"outline-primary"}
            title={registration.show_annotations_title(intl)}
            onClick={(e) => {
              e.preventDefault()
              toggleAnnotationsView()
            }}
          >
            <span className={"fa fa-eye"} aria-hidden="true" />
          </Button>
          <Button
            title={registration.delete_annotations_title(intl)}
            variant={"outline-primary"}
            disabled={annotations.length === 0}
            onClick={(e) => {
              e.preventDefault()
              $("#manage_annotations").hide()
              showModal(setShowEditModal)
            }}
          >
            <span className={"fa fa-pencil"} aria-hidden="true" />
          </Button>
        </div>
      </Popover.Body>
    </Popover>
  )

  return (
    <>
      {registration.annotations_allowed && (
        <>
          {showEditModal && (
            <EditAnnotationsModal
              show={showEditModal}
              onHide={() => hideModal(setShowEditModal)}
              exportBaseName={exportBaseName}
              run={run}
              annotations={annotations}
            />
          )}
          {showCreateModal && activeRun === run[id_accessor] && (
            <CreateAnnotationModal
              show={showCreateModal}
              onHide={hideCreateAnnotationsModal}
              plotList={plotList}
              exportBaseName={exportBaseName}
              run={run}
              graphKey={activeGraph}
              x_axis_value={x_axis_value}
            />
          )}
          <OverlayTrigger trigger="click" placement={placement} rootClose overlay={overlay}>
            <Button
              title={registration.manage_annotations_title(intl)}
              variant={"outline-primary"}
              className={show_annotation_lines ? "btn-selected" : ""}
            >
              <span className={"fa fa-comment"} aria-hidden="true" />
            </Button>
          </OverlayTrigger>
        </>
      )}
    </>
  )
}

export default withAnnotationsConfig(ToggleAnnotationsButton)
